'use client';

import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/Button';

interface InlineErrorProps {
    children: React.ReactNode;
    /** Allow the user to dismiss the error */
    dismissible?: boolean;
    /** Called when dismissed */
    onDismiss?: () => void;
    className?: string;
}

export function InlineError({
    children,
    dismissible = false,
    onDismiss,
    className = '',
}: InlineErrorProps) {
    const [dismissed, setDismissed] = useState(false);

    if (dismissed) return null;

    const handleDismiss = () => {
        setDismissed(true);
        onDismiss?.();
    };

    return (
        <div
            role="alert"
            className={`
                bg-rose-500/10 text-rose-400 border border-rose-500/20 rounded-lg
                px-3 py-2 text-sm
                flex items-start gap-2
                ${className}
            `}
        >
            <span className="flex-1">{children}</span>
            {dismissible && (
                <Button
                    type="button"
                    onClick={handleDismiss}
                    className="shrink-0 p-0.5 rounded hover:bg-rose-500/20 transition-colors"
                    aria-label="Dismiss error"
                >
                    <X className="w-3.5 h-3.5" />
                </Button>
            )}
        </div>
    );
}
